var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useClasses, useLayoutProps, useProps } from '@hawkins/helpers';
import { useDividerStyles } from './divider.styles';
var displayName = 'Divider';
/**
 * Dividers separate content into clear groups.
 */
export var Divider = forwardRef(function (props, ref) {
    var _a;
    // Props
    var _b = useProps(displayName, props), classesProp = _b.classes, className = _b.className, _c = _b.color, color = _c === void 0 ? 'light' : _c, _d = _b.component, Component = _d === void 0 ? 'div' : _d, layout = _b.layout, styleProp = _b.style, _e = _b.variant, variant = _e === void 0 ? 'horizontal' : _e, restProps = __rest(_b, ["classes", "className", "color", "component", "layout", "style", "variant"]);
    // Styles
    var baseClasses = useDividerStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var rootClassName = clsx(classes.HAWKINS_BASE, classes.root, className, (_a = {
            'Hawkins-horizontal-divider': variant === 'horizontal',
            'Hawkins-vertical-divider': variant === 'vertical',
            'Hawkins-table-divider': variant === 'table'
        },
        _a[classes.light] = color === 'light',
        _a[classes.xLight] = color === 'xLight',
        _a[classes.horizontal] = variant === 'horizontal',
        _a[classes.vertical] = variant === 'vertical',
        _a[classes.table] = variant === 'table',
        _a));
    var style = useLayoutProps({ layout: layout, style: styleProp });
    // Content
    return _jsx(Component, __assign({ className: rootClassName, style: style, ref: ref }, restProps));
});
Divider.displayName = displayName;
